















import productCardMixin from './product-card-mixin.coffee'
import getShopifyProduct from '~/queries/shopify-product.gql'

export default
	name: 'CbdOrHempProductCard'
	mixins: [ productCardMixin ]

	data: -> shopifyProduct: null

	fetch: ->
		# Get Shopify data
		{ product : shopifyProduct } = await @$storefront.execute
			query: getShopifyProduct
			variables: handle: @product.slug

		# Check that the product and variant exist
		return unless shopifyProduct
		@shopifyProduct = shopifyProduct

	fetchKey: (getCounter) ->
		@product.slug + getCounter('CbdOrHempProductCard')

	# Fire GTM impression event
	mounted: ->
		return unless @primaryVariant?.id
		@$gtmEcomm.productImpression @primaryVariant.id, el: @$el

	computed:

		# Get the primary variant
		primaryVariant: ->
			return unless @shopifyProduct?.variants
			@shopifyProduct?.variants[0]

		mergedProduct: -> {
			...@product
			...@shopifyProduct
		}

	methods:

		# Fire product click event
		fireProductClick: (clickEvent) ->
			return unless @primaryVariant?.id
			@$gtmEcomm.productClick @primaryVariant.id, {
				el: @$el
				clickEvent
			}

